import { createSelector } from 'reselect'
import { getPremiumPlusYearlyUrlUtil } from 'modules/training/modules/subscription/utils/get-premium-plus-yearly-url/index.js'
import { shouldShowUpgradeDiscountUserSelect } from 'modules/training/modules/training-users/selectors/should-show-upgrade-discount/index.js'
import { shouldShowNewCustomerDiscountUserSelect } from 'modules/training/modules/training-users/selectors/shouldShowNewCustomerDiscount/index.js'

export const getPremiumPlusYearlyUrlUserSelect = createSelector(
  shouldShowUpgradeDiscountUserSelect,
  shouldShowNewCustomerDiscountUserSelect,
  (
    shouldShowUpgradeDiscount,
    shouldShowNewCustomerDiscount
  ) => {
    return getPremiumPlusYearlyUrlUtil({
      shouldShowUpgradeDiscount,
      shouldShowNewCustomerDiscount
    })
  }
)
